import { KibsiClient } from './base';
const SERVICE = 'tenant';
export class TenantKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, SERVICE);
    }
    authCheck(requestConfig) {
        return this.post(`/auth/check`, requestConfig);
    }
    read(requestConfig) {
        return this.get(`/tenants/self`, requestConfig);
    }
    create(entity, requestConfig) {
        return this.post('/tenants', entity, requestConfig);
    }
    update(entity, requestConfig) {
        return this.put(`/tenants/self`, entity, requestConfig);
    }
    delete(requestConfig) {
        return this.del(`/tenants/self`, requestConfig);
    }
    passwordPolicy(requestConfig) {
        return this.get(`/tenants/self/passwordPolicy`, requestConfig);
    }
    claimMarketplace(marketplaceToken, requestConfig) {
        return this.post(`/tenants/self/claim-marketplace`, undefined, {
            ...requestConfig,
            params: { marketplaceToken },
        });
    }
}
//# sourceMappingURL=tenant.js.map